import React from "react";
import "./WhyOnlineBcom.css";

const benefits = [
  {
    number: "01",
    title: "Flexible Online Learning",
    description:
      "Learn at your own pace from anywhere while balancing studies, work, or personal commitments.",
  },
  {
    number: "02",
    title: "Industry-Relevant Curriculum",
    description:
      "Build expertise in accounting, taxation, finance, banking, business management, and commerce.",
  },
  {
    number: "03",
    title: "Experienced Faculty",
    description:
      "Learn from highly qualified academicians and industry professionals.",
  },
  {
    number: "04",
    title: "Practical Skill Development",
    description:
      "Gain analytical, financial, communication, and business decision-making skills.",
  },
  {
    number: "05",
    title: "Career Opportunities",
    description:
      "Prepare for careers in accounting, banking, taxation, auditing, finance, insurance, consulting, and business operations.",
  },
  {
    number: "06",
    title: "Higher Education Ready",
    description:
      "Build a strong academic foundation for MBA, M.Com, CA, CMA, CS, CFA, and other professional qualifications.",
  },
  {
    number: "07",
    title: "Modern Learning Platform",
    description:
      "Access recorded lectures, live classes, digital learning resources, quizzes, assignments, and discussion forums.",
  },
];

const WhyOnlineBcom = () => {
  return (
    <section className="why-bcom-section">
      <div className="container">
        <div className="why-bcom-heading-wrapper">
          <h2 className="why-bcom-heading-title">
            Why an Online B.Com. Might be the Right Choice for You
          </h2>
        </div>

        <div className="row">
          {benefits.map((benefit) => (
            <div className="col-12 col-md-6" key={benefit.number}>
              <div className="why-bcom-card">
                <div className="why-bcom-number-wrapper">
                  <span className="why-bcom-number">{benefit.number}</span>
                </div>

                <div className="why-bcom-content">
                  <h3 className="why-bcom-card-title">{benefit.title}</h3>

                  <p className="why-bcom-card-description">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyOnlineBcom;
